/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Nationality } from '../models/nationality';

@Injectable({
  providedIn: 'root',
})
export class NationalitiesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getNationalities
   */
  static readonly GetNationalitiesPath = '/api/v1/Nationalities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNationalities$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNationalities$Plain$Response(params?: {
    name?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Nationality>>> {

    const rb = new RequestBuilder(this.rootUrl, NationalitiesService.GetNationalitiesPath, 'get');
    if (params) {
      rb.query('name', params.name, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Nationality>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNationalities$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNationalities$Plain(params?: {
    name?: string;
  },
  context?: HttpContext

): Observable<Array<Nationality>> {

    return this.getNationalities$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Nationality>>) => r.body as Array<Nationality>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNationalities()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNationalities$Response(params?: {
    name?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Nationality>>> {

    const rb = new RequestBuilder(this.rootUrl, NationalitiesService.GetNationalitiesPath, 'get');
    if (params) {
      rb.query('name', params.name, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Nationality>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNationalities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNationalities(params?: {
    name?: string;
  },
  context?: HttpContext

): Observable<Array<Nationality>> {

    return this.getNationalities$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Nationality>>) => r.body as Array<Nationality>)
    );
  }

}
